import Client from './client';

export default class ChannelOrganizationShopify extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postShopifyAndInstall(channelId, options = {}) {
    return this.makeRequest(`${this.host}/channel/${channelId}/organizations/shopify/install`, {
      ...options,
       method: 'POST',
    });
  }

  putShopifyAndInstallByKey(channelId, key, options = {}) {
    return this.makeRequest(`${this.host}/channel/${channelId}/organizations/shopify/install/${key}`, {
      ...options,
       method: 'PUT',
    });
  }

}
